module.exports = __webpack_public_path__ + "img/floorplan.01d88fc3.jpg";